/*
 * @Author: your name
 * @Date: 2022-02-07 15:23:26
 * @LastEditTime: 2023-12-27 11:37:02
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsySelectCheckBox\index.jsx
 */
import React, { Component } from 'react';
import { BsyUtils } from '../../utils/Utils';

import BsySelectList from '../BsySelectList';
import BsyTextEditor from '../BsyTextEditor';
import './index.css'
import { BsyConfig } from '../../global/BsyConfig';

export default class BsyDeptCheckList extends BsySelectList {

    constructor(props) {
        super({
            // baseCls: "fx_dept_check",
            waterMark: null,
            hasSelectAll: !0,
            BsyDeptCheckList: !0,
            hasSelectCurrent: !0,
            textField: "name",
            valueField: "_id",
            searchable: !0,
            onStopEdit: null,
            height: 30,
            // width: 350,
            edge: {
                width: 240,
                height: 330
            },
            value: {
                items: []
            },
            dynamicType: "select",
            limit: {},
            searchKey: "keyword",
            hasScrollLoad: !1,
            multiSelect: !0,
            allowBlank: !1,
            parentDepts: [],
            async: true,
            ...props
        });
        this.state = {
            ...this.state,
            rsync: true,
            value: this.value2statevalue(this.options.value)
        }
        this.page = 0;
        this.isAllSelect = false;
    }

    getOrgValue = (a) => {
        const { items, value } = this.state
        const { valueField, textField, multiSelect } = this.options;

        let newdd = [];
        let foreachChild = (data) => {
            data && data.map((val) => {

                if (a.indexOf(val[valueField]) > -1) {
                    newdd.push(val[valueField])
                }
                if (val.children) {
                    foreachChild(val.children)
                }
            })
        }
        foreachChild(items)

        return newdd;
    }

    componentDidMount() {
        super.componentDidMount();

        if (BsyUtils.isObjectEmpty(window.FX.STATIC[window.FX.STATIC.APPID + window.FX.STATIC.ENTRYID + "G_Departments"])) {
            this.loadData(0, () => {
                // if (this.props.onStopEdit) {
                //     this.props.onStopEdit(this.state.value)
                // }

            });
        } else {
            this.isSelectAll([...window.FX.STATIC[window.FX.STATIC.APPID + window.FX.STATIC.ENTRYID + "G_Departments"]])
            this.setState({
                items: [...window.FX.STATIC[window.FX.STATIC.APPID + window.FX.STATIC.ENTRYID + "G_Departments"]],
            }, () => {
                // if (this.props.onStopEdit) {
                //     this.props.onStopEdit(this.state.value)
                // }
            })
        }



    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {

        let pvalue = this.value2statevalue(nextProps.value);
        if (!BsyUtils.compare(this.state.value, pvalue)) {
            this.setState({
                value: [...pvalue],
            }, () => {

            })
        }
    }

    transformToTreeFormat = (b) => {
        let simpleData = {
            enable: true,
            idKey: "departmentId",
            pIdKey: "parentId"
        }
        var c, d, e = simpleData.idKey, f = simpleData.pIdKey, g = 'children';
        if (!e || "" == e || !b)
            return [];
        if (Array.isArray(b)) {
            var h = []
                , i = [];
            for (c = 0, d = b.length; c < d; c++) {
                i[b[c][e]] = b[c];
            }

            for (c = 0, d = b.length; c < d; c++) {

                if (i[b[c][f]] && b[c][e] != b[c][f]) {
                    i[b[c][f]][g] || (i[b[c][f]][g] = [])


                    b[c].title = b[c].name;
                    b[c].key = b[c].departmentId;
                    i[b[c][f]][g].push(b[c])
                } else {
                    b[c].title = b[c].name;
                    b[c].key = b[c].departmentId;
                    h.push(b[c])
                }

            }
            return h
        }
        b.title = b.name;
        b.key = b.departmentId;
        return [b]
    }

    selectItem = (val) => {
        return () => {
            const { items, value } = this.state
            const { textField, valueField, multiSelect } = this.options;

            let values = [];
            let isallSelect = true;
            let showList = true;
            if (multiSelect) {
                let foreachChild = (data) => {
                    data && data.map((val) => {

                        if (values.indexOf(val) == -1) {
                            isallSelect = false;
                        }
                        if (val.children) {
                            foreachChild(val.children)
                        }
                    })
                }
                values = [...value];
                if (values.indexOf(val) == -1) {
                    values.push(val);

                    foreachChild(items)
                } else {
                    let i = values.indexOf(val);
                    values.splice(i, 1);
                    isallSelect = false;
                }
                this.isAllSelect = isallSelect;
            } else {
                values = val;
                showList = false;
            }
            this.setState({
                value: values,
                showList: showList
            }, () => {
                if (this.props.onStopEdit) {
                    this.props.onStopEdit(this.getValue())
                }
            })
        }
    }

    loadData = (skip, cb) => {

        const { hasSelectEmpty, hasCurrentDept, hasCurrentSubDept, hasParentsDept, hasCurrentParDept, dynamicType } = this.options;

        let items = [];

        if (hasSelectEmpty) {

            items.push({
                _id: BsyConfig().CONST.PARAMETER.EMPTY,
                name: React.language("unfilled")
            })
        }
        if (!window.FX.STATIC.QTOKEN) {


        } else {
            this.setState({
                items: items,
            }, () => {
                cb && cb()
            })
            return
        }



        // items.push({
        //     _id: BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT,
        //     name: React.language("department.sub.department")
        // });

        // items.push({
        //     _id: BsyConfig().CONST.DEPT_ID.CURRENT,
        //     name: React.language("dept.current")
        // })

        React.axios('/data/member/departments', {
            appId: window.FX.STATIC.APPID
        }).then(res => {
            BsyUtils.showAjaxTip(res.data, () => {
                let dd = this.transformToTreeFormat(res.data['departments'])
                // console.log(dd)
                if (!window.FX.STATIC.QTOKEN) {
                    items.push({
                        _id: "organization",
                        name: React.language("organization"),
                        // icon: 'icon-bsy-organization',
                        fixed: true,
                    })
                    dd[0].open = true;
                }

                items = [...items, ...dd];

                React.axios('/data/outsider/list', {
                    appId: window.FX.STATIC.APPID
                }).then(res => {
                    BsyUtils.showAjaxTip(res.data, () => {
                        if (!window.FX.STATIC.QTOKEN) {
                            items.push({
                                _id: "outsiderGroup",
                                name: React.language("outsiderGroup"),
                                // icon: 'icon-bsy-outsiderGroup',
                                fixed: true,
                            })
                        }

                        items = [...items, ...res.data['list']];
                        //当前页面有多个部门筛选条件请求的时候，临时缓存，减少不必要的请求

                    

                        window.FX.STATIC[window.FX.STATIC.APPID + window.FX.STATIC.ENTRYID + "G_Departments"] = [...items];
                        this.isSelectAll([...items])
                        this.setState({
                            items: items,
                        }, () => {
                            cb && cb()
                        })
                    })

                }).catch(res => {
                    console.error(res);
                    this.setState({
                        items: items,
                    }, () => {
                        cb && cb()
                    })
                })

            })

        }).catch(res => {
            console.error(res);
            this.setState({
                items: items,
            }, () => {
                cb && cb()
            })
        })

    }



    value2statevalue = (t) => {
        let val = [];
        if (BsyUtils.isObjectEmpty(t))
            return val;
        if (Array.isArray(t)) {
            val = t;
        } else {
            if (t) {
                if (!t.parentDepts) {
                    t.parentDepts = []
                }
    
                if (!t.items) {
                    t.items = []
                }
                
                if(!t.value) {
                    t.value = [];
                }
      
                if (BsyUtils.isString(t.value)) {
                    val = [...val, ...[t.value]];
                } else {
                    val = [...val, ...t.value];
                }
                val = [...val, ...t.items];
                val = [...val, ...t.parentDepts];
                if (t.hasEmpty) {
                    val.push(BsyConfig().CONST.PARAMETER.EMPTY)
                }
                if (t.hasCurrentDept) {
                    val.push(BsyConfig().CONST.DEPT_ID.CURRENT)
                }
                if (t.hasCurrentSubDept) {
                    val.push(BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT)
                }
                if (t.hasCurrentParDept) {
                    val.push(BsyConfig().CONST.DEPT_ID.CURRENT_PARDEPT)
                }
            }
        }

        return val;

    }

    getValue = () => {


        if (BsyUtils.isObjectEmpty(this.state.value))
            return {};
        var t = [].concat(this.state.value)
            , e = !1
            , i = !1
            , j = !1
            , a = [];
        var parents = [];
        var hasCurrentParDept = !1;
        BsyUtils.forEach(t, function (t, n) {
            switch (n) {
                case BsyConfig().CONST.PARAMETER.EMPTY:
                    e = !0;
                    break;
                case BsyConfig().CONST.DEPT_ID.CURRENT:
                    i = !0;
                    break;
                case BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT:
                    j = !0;
                    break;
                case BsyConfig().CONST.DEPT_ID.CURRENT_PARDEPT:
                    hasCurrentParDept = !0;
                    break;
                case BsyConfig().CONST.DEPT_ID.CURRENT2:
                case BsyConfig().CONST.DEPT_ID.CURRENT3:
                case BsyConfig().CONST.DEPT_ID.CURRENT4:
                case BsyConfig().CONST.DEPT_ID.CURRENT5:
                    parents.push(n);
                    break;
                default:
                    a.push(n)
            }
        })

        let dd = this.getOrgValue(a);

        return {
            hasCurrentDept: i,
            hasCurrentSubDept: j,
            hasCurrentParDept: hasCurrentParDept,
            hasEmpty: e,
            items: dd,
            parentDepts: parents
        }
    }

    onSelectAll = () => {
        const { isAllSelect } = this
        const { items, value } = this.state
        const { valueField } = this.options
        let tmpvalue = value ? [...value] : [];

        let isallSelect = !isAllSelect;
        let values = [];


        let foreachChild = (data) => {
            data && data.map((val) => {

                if (isallSelect) {
                    if (!val.fixed) {
                        let d = tmpvalue.indexOf(data[valueField]);
                        if (d == -1) {
                            values.push(val[valueField]);
                        }
                    }
                }
                if (val.children) {
                    foreachChild(val.children)
                }
            })
        }
        foreachChild(items)

        this.isAllSelect = isallSelect;
        if (!this.isAllSelect) {
            values = [];
        }
        this.setState({
            value: values,
        }, () => {
            if (this.props.onStopEdit) {
                this.props.onStopEdit(this.state.value)
            }
        })

    }

    isSelectAll = (items) => {

        this.isAllSelect = true;
        let foreachChild = (data) => {
            data && data.map((dd) => {
                if (dd.fixed) {
                    return dd;
                }
                if (this.state.value && this.state.value.indexOf(dd[this.options.valueField]) === -1) {
                    this.isAllSelect = false;
                    return false;
                }
                if (dd.children) {
                    foreachChild(dd.children)
                }
            })
        }
        foreachChild(items)
    }

    renderChildNode = (data, index) => {
        const { multiSelect, textField, valueField } = this.options
        const { value } = this.state;
        return (<>
            {
                data && data.map((val) => {
                    let selected = val.selected;
                    let classNames = ''


                    if (val.fixed) {

                        return <div key={val[valueField]} className={'item bsy-x-check fixed'} >
                            <i className={val.icon}></i>
                            <span>
                                {
                                    val[textField]
                                }
                            </span>
                        </div>
                    }

                    if (multiSelect) {
                        selected = value.indexOf(val[valueField]) > -1
                        classNames = selected ? " item bsy-x-check select " : "item bsy-x-check "
                    } else {
                        selected = value === val[valueField];
                        classNames = selected ? "item select " : "item "
                    }


                    if (val.hasOwnProperty('corpId'))
                        classNames = classNames + ' csp-' + index;

                    if (val.hasOwnProperty('corpId')) {
                        return <div key={val[valueField]} className={(val.open ? "expand" : '') + '  pid-' + val._id} >
                            <div
                                title={val[textField]}
                                onClick={this.selectItem(val[valueField])} className={classNames}>
                                {
                                    //折叠
                                    val.hasOwnProperty('corpId') && val.children && val.children.length > 0 ? <i
                                        onClick={(e) => {
                                            let tag = this.elementRef.current.querySelector('.pid-' + val._id)
                                            if (tag) {
                                                if (tag.classList.contains('expand')) {
                                                    tag.classList.remove('expand')
                                                    if (tag.querySelector('.children'))
                                                        tag.querySelector('.children').style.display = 'none'
                                                    if (tag.querySelector('.open')) {
                                                        tag.querySelector('.open').classList.remove('icon-tree-collapse')
                                                        tag.querySelector('.open').classList.add('icon-tree-expand')
                                                    }
                                                } else {
                                                    tag.classList.add('expand')
                                                    if (tag.querySelector('.children'))
                                                        tag.querySelector('.children').style.display = ''
                                                    if (tag.querySelector('.open')) {
                                                        tag.querySelector('.open').classList.add('icon-tree-collapse')
                                                        tag.querySelector('.open').classList.remove('icon-tree-expand')
                                                    }
                                                }
                                            }
                                            e.stopPropagation();
                                        }}

                                        className={val.open ? " open icon-tree-collapse" : " open icon-tree-expand"}></i> : <i className='blank'></i>
                                }
                                {
                                    //多选的效果
                                    multiSelect && <i className="icon-blank"></i>
                                }
                                {
                                    //部门标识
                                    val.hasOwnProperty('corpId') && <i className="icon-dept-title"></i>
                                }
                                <span>
                                    {
                                        val[textField]
                                    }
                                </span>

                            </div>
                            {
                                val.children && <div className={'children'}
                                    style={{
                                        display: val.open ? '' : 'none'
                                    }}
                                >
                                    {
                                        this.renderChildNode(val.children, index + 1)
                                    }
                                </div>
                            }
                        </div>
                    }
                    return <div key={val[valueField]}
                        title={val[textField]}
                        onClick={this.selectItem(val[valueField])} className={classNames}>
                        {
                            //多选的效果
                            multiSelect && <i className="icon-blank"></i>
                        }
                        <span>
                            {
                                val[textField]
                            }
                        </span>

                    </div>

                })
            }
        </>)
    }

    renderDD = () => {
        const { items } = this.state
        const { hasSelectEmpty, emptyId, hasCurrentDept, hasCurrentSubDept, hasParentsDept, hasCurrentParDept, dynamicType } = this.options;
        if (items) {

            let ddc = [...items];
            if (!window.FX.STATIC.QTOKEN) {
                if (hasCurrentDept || hasCurrentSubDept || hasParentsDept || hasCurrentParDept) {
                    if ("set" === dynamicType) {
                        if (!window.FX.STATIC.QTOKEN) {
                            ddc.push({
                                _id: "dynamic",
                                name: React.language("dynamic") + React.language("department"),
                                // icon: 'icon-bsy-dynamic',
                                fixed: true,
                            })
                        }
                        ddc = ddc.concat([
                            {
                                _id: BsyConfig().CONST.DEPT_ID.CURRENT,
                                name: React.language("dept.current")
                            },
                            {
                                _id: BsyConfig().CONST.DEPT_ID.CURRENT2,
                                name: React.language("top.department")
                            },
                            {
                                _id: BsyConfig().CONST.DEPT_ID.CURRENT3,
                                name: React.language("tertiary.department")
                            },
                            {
                                _id: BsyConfig().CONST.DEPT_ID.CURRENT4,
                                name: React.language("fourth.department")
                            },
                            {
                                _id: BsyConfig().CONST.DEPT_ID.CURRENT5,
                                name: React.language("fifth.department")
                            },
                            {
                                _id: BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT,
                                name: React.language("department.sub.department")
                            },
                            {
                                _id: BsyConfig().CONST.DEPT_ID.CURRENT_PARDEPT,
                                name: React.language("department.hasCurrentParDept")
                            },

                        ])
                    }
                }
            }

            return this.renderChildNode(ddc, 0)

        }
        return <></>
    }

    seachCallBack = () => {
        const { items } = this.state
        const { valueField, textField } = this.options;
        if (!this.searchValue) {
            this.setState({
                items: this.bakAllitems,
                seaching: false,
            }, () => {
                this.bakAllitems = null;
            })
        } else {
            if (BsyUtils.isObjectEmpty(this.bakAllitems)) {
                this.bakAllitems = [...items]
            }

            let searchValue = [];

            let foreachChild = (data) => {
                data && data.map((val) => {

                    if (val[textField].indexOf(this.searchValue) > -1) {
                        searchValue.push({
                            [textField]: val[textField],
                            [valueField]: val[valueField],
                        })
                    }


                    if (val.children) {
                        foreachChild(val.children)
                    }
                })
            }
            foreachChild(this.bakAllitems)

            this.setState({
                items: searchValue,
                seaching: false,
            })
        }

    }

    renderSelectList = () => {
        const { searchable, hasSelectAll, multiSelect, } = this.options
        const { css, seaching } = this.state
        const { isAllSelect } = this

        return <>
            {
                searchable ? <div className='bsy-combo-search' >
                    <BsyTextEditor
                        onAfterEdit={this.seachItems}
                        waterMark={React.language("search")}
                        width={"100%"}
                        value={this.searchValue}
                    ></BsyTextEditor>

                </div> : <></>
            }
            <div style={css} className="selectList">

                {
                    seaching && <div className='loading-text'>
                        <span>{React.language('searching')}</span>
                    </div>
                }

                {
                    multiSelect && (!seaching && hasSelectAll) ? <div key={'all'}
                        onClick={this.onSelectAll}
                        className={"item bsy-x-check select-all field-meta " + (isAllSelect ? 'select' : '')}

                    >
                        <i className="icon-blank"></i>
                        <span style={{color: '#0265ff'}}>
                            {
                                React.language('selectAll')
                            }
                        </span>
                    </div> : <></>
                }


                {

                    !seaching && this.renderDD()

                }
            </div>
        </>

    }

    showItem = () => {

        const { items, value } = this.state
        const { valueField, textField } = this.options;
        let text = [];
        let valuess = [];

        if (BsyUtils.isObjectEmpty(value)) {
            return text;
        }
        let dd = items.concat([
            {
                _id: BsyConfig().CONST.DEPT_ID.CURRENT,
                name: React.language("dept.current")
            },
            {
                _id: BsyConfig().CONST.DEPT_ID.CURRENT2,
                name: React.language("top.department")
            },
            {
                _id: BsyConfig().CONST.DEPT_ID.CURRENT3,
                name: React.language("tertiary.department")
            },
            {
                _id: BsyConfig().CONST.DEPT_ID.CURRENT4,
                name: React.language("fourth.department")
            },
            {
                _id: BsyConfig().CONST.DEPT_ID.CURRENT5,
                name: React.language("fifth.department")
            },
            {
                _id: BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT,
                name: React.language("department.sub.department")
            },
            {
                _id: BsyConfig().CONST.DEPT_ID.CURRENT_PARDEPT,
                name: React.language("department.hasCurrentParDept")
            },

        ])

        let foreachChild = (data) => {
            data && data.map((val) => {

                if ((val.selected || value.indexOf(val[valueField]) > -1)) {

                    if (!BsyUtils.isObjectEmpty(val[valueField])) {
                        text.push(val[textField])
                        valuess.push(val[valueField])
                    }
                }
                if (val.children) {
                    foreachChild(val.children)
                }
            })
        }
        foreachChild(dd)
        value.map((data) => {

            if (valuess.indexOf(data) === -1) {
                text.push(data);
            }
        })

        return text
    }

}
